export default "__VITE_ASSET__BcYuz1q3__"